export enum ScannerMode {
  ASSIGN = 'ASSIGN',
  RETURN = 'RETURN',
  CARD_UPGRADE = 'CARD_UPGRADE',
  REPORT_DAMAGED_ITEM = 'REPORT_DAMAGED_ITEM',
  DEPOSIT_ASSIGN = 'DEPOSIT_ASSIGN',
  DEPOSIT_RETURN = 'DEPOSIT_RETURN',
}
